import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';

import { TranslationService } from './translation.service';
import { ReadyService } from './ready.service';
import { InternalLanguageKeyMap } from './locale.constants';

export function InternalLanguageKeyMapFactory(): InternalLanguageKeyMap {
  return new InternalLanguageKeyMap();
}

export function provideCoreTranslation(): EnvironmentProviders {
  return makeEnvironmentProviders([
    ReadyService,
    TranslationService,
    {
      provide: InternalLanguageKeyMap,
      useFactory: InternalLanguageKeyMapFactory,
      deps: []
    },
    provideAppInitializer(() => {
      inject(TranslationService).onInit();
    })
  ]);
}
